import * as React from 'react';

import { mergeStyles } from '@cian/components';

import { Rating } from '../../common/components/rating';
import { IconQuestion } from './icons/icon_question';

import * as Analytics from './tracking';

import * as styles from './index.css';

export interface IBtiDistrictRatingData {
  ecologyIndex?: number;
  infrastructureIndex?: number;
  safetyIndex?: number;
  surroundBad?: number;
  surroundPlus?: number;
  transportIndex?: number;
}

type TRatingLocation = IBtiDistrictRatingData | null;

export interface IBtiDistrictRatingProps {
  ratingLocation: TRatingLocation;
}

export class BtiDistrictRating extends React.Component<IBtiDistrictRatingProps, {}> {
  public render() {
    if (checkBtiDistrictRatingHidden(this.props.ratingLocation)) {
      return null;
    }

    const {
      ecologyIndex,
      infrastructureIndex,
      safetyIndex,
      surroundBad,
      surroundPlus,
      transportIndex,
    } = this.props.ratingLocation as IBtiDistrictRatingData;

    return (
      <div className={styles['container']}>
        <div className={styles['title']}>
          Рейтинг района
          <a
            href="/help/cian-for-professionals/37717/"
            target="_blank"
            onClick={Analytics.trackClickDistrictRating}
          >
            <IconQuestion />
          </a>
        </div>
        <div className={styles['content']}>
          <div className={styles['column']}>
            <div className={styles['item']}>
              <div className={styles['name']}>Транспорт</div>
              <div {...mergeStyles(
                styles['value'],
                styles['rating'],
              )}>
                {
                  !!transportIndex
                    ? <Rating rating={transportIndex} />
                    : '-'
                }
              </div>
            </div>
            <div className={styles['item']}>
              <div className={styles['name']}>Инфраструктура</div>
              <div {...mergeStyles(
                styles['value'],
                styles['rating'],
              )}>
                {
                  !!infrastructureIndex
                    ? <Rating rating={infrastructureIndex} />
                    : '-'
                }
              </div>
            </div>
            <div className={styles['item']}>
              <div className={styles['name']}>Экология</div>
              <div {...mergeStyles(
                styles['value'],
                styles['rating'],
              )}>
                {
                  !!ecologyIndex
                    ? <Rating rating={ecologyIndex} />
                    : '-'
                }
              </div>
            </div>
          </div>
          <div className={styles['column']}>
            <div className={styles['item']}>
              <div className={styles['name']}>Безопасность</div>
              <div {...mergeStyles(
                styles['value'],
                styles['rating'],
              )}>
                {
                  !!safetyIndex
                    ? <Rating rating={safetyIndex} />
                    : '-'
                }
              </div>
            </div>
            <div className={styles['item']}>
              <div className={styles['name']}>Положительное соседство</div>
              <div {...mergeStyles(
                styles['value'],
                styles['rating'],
              )}>
                {
                  !!surroundPlus
                    ? <Rating rating={surroundPlus} />
                    : '-'
                }
              </div>
            </div>
            <div className={styles['item']}>
              <div className={styles['name']}>Отрицательное соседство</div>
              <div {...mergeStyles(
                styles['value'],
                styles['rating'],
              )}>
                {
                  !!surroundBad
                    ? <Rating rating={surroundBad} />
                    : '-'
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function checkBtiDistrictRatingHidden(ratingLocation: TRatingLocation): boolean {
  return !ratingLocation;
}
